<template>
  <div class="role-manage">
    <div class="role-tree">
      <div class="title">角色列表</div>
      <div class="content">
        <div class="content-inner">
          <el-input v-model="roleKeyword" placeholder="关键字过滤"></el-input>
          <ul class="roleList">
            <li class="aRole disabledRole">
              <div class="custom-tree-node">
                <span>system</span>运动员
              </div>
              <div class="tree-btn">
                <el-button type="text" size="mini">
                  <i class="el-icon-remove-outline"></i>删除
                </el-button>
              </div>
            </li>
            <li class="aRole disabledRole">
              <div class="custom-tree-node">
                <span>system</span>运动员
              </div>
              <div class="tree-btn">
                <el-button type="text" size="mini">
                  <i class="el-icon-remove-outline"></i>删除
                </el-button>
              </div>
            </li>
            <li class="aRole disabledRole">
              <div class="custom-tree-node">
                <span>system</span>运动员
              </div>
              <div class="tree-btn">
                <el-button type="text" size="mini">
                  <i class="el-icon-remove-outline"></i>删除
                </el-button>
              </div>
            </li>
            <li class="aRole">
              <div class="custom-tree-node">
                <span class="green">OPR</span>运动员
              </div>
              <div class="tree-btn">
                <el-button type="text" size="mini">
                  <i class="el-icon-remove-outline"></i>删除
                </el-button>
              </div>
            </li>
            <li class="aRole">
              <div class="custom-tree-node">
                <span class="orange">ListenU</span>运动员
              </div>
              <div class="tree-btn">
                <el-button type="text" size="mini">
                  <i class="el-icon-remove-outline"></i>删除
                </el-button>
              </div>
            </li>
          </ul>
        </div>
        <el-button class="tree-btn-root" type="text" size="mini" @click="appendRoot">
          <i class="el-icon-circle-plus-outline"></i>新增角色
        </el-button>
      </div>
    </div>
    <div class="menu-setting">
      <div class="title">角色设置</div>
      <div class="content">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index">{{ item }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :ref="'pageDirect'" :model="selectData" label-width="98px">
          <div class="setting-item">
            <el-divider content-position="left"><i class="el-icon-s-tools"></i>基础设置</el-divider>
            <el-form-item label="角色归属：">
              <el-select v-model="selectData.role" :placeholder="'请选择角色归属'" style="width: 250px" clearable>
                <el-option
                  v-for="item in roleOptions"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色编码：" required>
              <el-input v-model="selectData.roleCode" :placeholder="'请输入角色编码'" style="width: 250px"
                        maxlength="25" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="角色名称：">
              <el-input v-model="selectData.roleName" :placeholder="'请输入角色名称'" style="width: 250px"
                        maxlength="25" show-word-limit clearable></el-input>
            </el-form-item>
          </div>
          <div class="setting-item">
            <el-divider content-position="left"><i class="el-icon-user-solid"></i>授权设置</el-divider>
            <div class="custom-transfer">
              <el-transfer style="text-align: left; display: inline-block" v-model="roleMenus" filterable
                           :props="{ key: 'id' }" :titles="['可选菜单', '授权菜单']"
                           :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                           @change="handleChange" :data="roles">
                                <span slot-scope="{ option }">
                                  {{ option.label }}
                                </span>
              </el-transfer>
            </div>
          </div>
          <div class="footer">
            <el-button style="margin-left: 20px;" size="small" @click="saveData">
              保存
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Icons from '@/utils/icons';

export default {
  data: function () {
    return {
      roleKeyword: '', // 关键字
      icons: Icons,
      menus: [],
      pages: [],
      roles: [{
        label: '零听->门店统计',
        id: '1'
      },
        {
          label: '零听->问卷管理',
          id: '2'
        },
        {
          label: '零听->问卷管理->题库管理',
          id: '3'
        },
        {
          label: '零听->主问卷',
          id: '4'
        }],
      roleMenus: [

      ],
      selectData: {},
      breadcrumb: [],
      roleOptions: [
        {
          key: 'ListenU零听',
          value: 1
        },
        {
          key: 'OPR',
          value: 2
        },
        {
          key: 'VMS',
          value: 3
        }
      ],
      roleType: [
        'System',
        'ListenU',
        'VMS',
        'OPR'
      ],
      roleTypeCss: [
        '',
        'listen',
        'vms',
        'opr'
      ],
    }
  },
  mounted: function () {
    this.getRoles()
    this.getPages()
    // this.getMenus()
  },
  methods: {
    // 获取所有页面
    getRoles: async function () {
      this.roles = await this.$api.retail_api.getAllRole();
    },
    getPages: async function () {
      this.pages = await this.$api.retail_api.getAllPage();
    },
    // 获取所有菜单
    getMenus: async function () {
      let _this = this;
      this.menus = await this.$api.retail_api.getMenuTree();
      this.$nextTick(async () => {
        _this.selectData = _this.$refs.tree.root.data[0];
        let result = await _this.$api.retail_api.getBindRoles(_this.selectData.id);
        if (result) {
          _this.$set(_this, 'roleMenus', result.map(i => i));
        }
        _this.breadcrumb = [];
        _this.breadcrumb.push(_this.selectData.label);
      })
    },
    reloadPage: async function () {
      let pages = this.$router.options.routes[1].children.filter(i => i.path != '/').map(i => {
        return {name: i.name, path: i.path};
      });
      await this.$api.retail_api.registerPage(pages);
      await this.getPages();
    },
    // 新增子节点
    append: async function (data) {
      let sort = data.children.length + 1;
      const newChild = {id: 0, parentId: data.id, sort: sort, label: 'default', icon: '', children: []};
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      let result = await this.$api.retail_api.createMenu(newChild);

      if (result) {
        data.children.push(result);
      }

      if (data.children.length > 0) {
        this.sortChange(data.children);
      }
    },
    // 新增根节点
    appendRoot: async function () {
      let sort = this.menus.length + 1;
      const newChild = {id: 0, parentId: 0, sort: sort, label: 'default', icon: '', children: []};
      let result = await this.$api.retail_api.createMenu(newChild);
      if (result) {
        this.menus.push(result);
      }
      this.sortChange(this.menus);
    },
    // 移除菜单
    remove: function (node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.$treeNodeId === data.$treeNodeId);
      children.splice(index, 1);
      if (children.length > 0) {
        this.sortChange(children);
      }
      this.$api.retail_api.deleteMenu(data.id);
    },
    // 拖动结束位置
    handleDragEnd: function (draggingNode, dropNode, dropType, ev) {
      if (dropType == "inner") {
        draggingNode.data.parentId = dropNode.data.id;
      } else if (dropType == "none") {
        // do nothing
      } else {
        draggingNode.data.parentId = dropNode.data.parentId;
      }

      this.$api.retail_api.editMenu(draggingNode.data)

      if (Array.isArray(dropNode.parent.data)) {
        this.sortChange(dropNode.parent.data)
      } else {
        this.sortChange(dropNode.parent.data.children)
      }


    },
    // 重排序
    sortChange(list) {
      let ids = list.map(val => val.id);
      this.$api.retail_api.sortMenu(ids);
      list.forEach((val, index) => val.sort = index + 1);
    },
    // 节点选择
    nodeSelect: async function (node, data) {
      this.breadcrumb = [];
      this.buildBreadcrump(node);
      this.selectData = data;
      let result = await this.$api.retail_api.getBindRoles(data.id);
      if (result) {
        this.$nextTick(() => {
          this.$set(this, 'roleMenus', result.map(i => i));
        })
      }
    },
    // 构建面包屑
    buildBreadcrump: function (node) {
      if (node.parent) {
        this.buildBreadcrump(node.parent);
      }
      if (node.data.label) {
        this.breadcrumb.push(node.data.label);
      }
    },
    // 页面绑定切换
    pageBindChage: function (val) {
      if (val) {
        this.selectData.path = this.pages.filter(i => i.name == val)[0].path;
      } else {
        this.selectData.path = '';
      }
    },
    handleChange(value, direction, movedKeys) {
      this.roleMenus = value;
    },
    saveData: async function () {
      this.$api.retail_api.bindMenuRole({id: this.selectData.id, ids: this.roleMenus});
      let result = await this.$api.retail_api.editMenu(this.selectData)
      if (result) {
        this.$message.info("操作成功！")
      }
    }
  },
  watch: {
    'selectData.label': function (val) {
      this.breadcrumb[this.breadcrumb.length - 1] = val;
      this.$set(this, 'breadcrumb', this.breadcrumb)
    }
  }
}
</script>
<style scoped lang="scss">
.role-manage {
  padding: var(--pad);
  width: 100%;
  height: 100%;
  display: flex;

  .title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    border-bottom: 1px solid #ebeef5
  }

  .content {
    width: 100%;
    height: calc(100% - 40px);
  }

  .role-tree {
    height: 100%;
    width: 280px;
    border: 1px solid #ebeef5;
    background-color: white;

    .content {
      padding: 12px;
      .content-inner {
        height: calc(100% - 24px);
        overflow-y: auto;
        scroll-behavior: smooth;

        &::-webkit-scrollbar {
          width: 3px;
          height: 0px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #c0c4cc;
        }
      }

      .roleList {
        list-style: none;
        margin-top: 10px;
        .aRole {
          height: 26px;
          display: flex;
          margin: 4px 0;
          justify-content: space-between;
          .custom-tree-node {
            display: flex;
            height: 26px;
            line-height: 26px;
            span {
              width: 50px;
              text-align: center;
              color: white;
              margin-right: 8px;
            }
            span.orange {
              background: #ff6801;
            }
            span.green {
              background: #67C23A;
            }
            .tree-label {
              width: 120px;
            }

            .tree-btn {
              position: absolute;
              right: var(--pad);
            }
          }
        }
        .disabledRole {
          span {
            background: #cccccc;
          }
          .tree-btn {
            color: #ccc;
            .el-button--text {
              color: #ccc;
            }
          }
        }
      }
    }

    .tree-btn-root {
      width: 100%;
    }
  }

  .menu-setting {
    margin-left: var(--pad);
    height: 100%;
    width: calc(100% - 300px);
    border: 1px solid #ebeef5;
    background-color: white;

    .content {
      padding: var(--pad);
      position: relative;

      .setting-item {
        margin-top: 20px;

        .custom-transfer {
          width: 100%;

          /deep/ .el-transfer-panel {
            width: 400px;
            height: 350px;

            .el-transfer-panel__filter .el-input__inner {
              border-radius: 0;
            }

            .el-transfer-panel__list.is-filterable {
              height: 250px;

              &::-webkit-scrollbar {
                width: 3px;
                height: 0px;
              }

              &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
              }
            }

            .el-transfer-panel__item.el-checkbox {
              margin-bottom: 5px;
            }
          }

          .type-tag {
            width: 50px;
            display: inline-block;
            text-align: center;
            margin-left: 10px;
            margin-right: 10px;
            color: #fff;
            background-color: #c0c4cc;

            &.listen {
              background-color: #ff6801;
              color: #fff;
            }

            &.vms {
              background-color: #ff6801;
              color: #000;
            }

            &.opr {
              background-color: #67C23A;
            }
          }
        }

      }

      .direct-inner {
        height: 100px;

        &.no-children {
          padding-top: 30px;
          text-align: center;
          font-size: 24px;
          color: #ebeef5;
        }

        .el-icon-refresh {
          font-size: 20px;
          cursor: pointer;

          @keyframes rotate {
            0% {
              -webkit-transform: rotate(0deg);
            }

            25% {
              -webkit-transform: rotate(90deg);
            }

            50% {
              -webkit-transform: rotate(180deg);
            }

            75% {
              -webkit-transform: rotate(270deg);
            }

            100% {
              -webkit-transform: rotate(360deg);
            }
          }

          &:hover {
            animation: rotate 2s linear infinite;
          }
        }
      }

      .footer {
        position: absolute;
        bottom: 20px;
        width: calc(100% - 40px);
        margin-left: 440px;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/setting/roleManage.vue